import { useParams } from "react-router-dom";

import { useQuery } from "@apollo/client";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { CofConfigId } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import {
    type GetAllPreSubmissionInfoWithOrgResourcesQuery,
    type GetAllPreSubmissionInfoWithOrgResourcesQueryVariables,
    getAllPreSubmissionInfoWithOrgResources,
} from "../api/queries";
import { getPreSubmissionInfoQuery } from "../api/queries/getPreSubmissionInfo";
import {
    type GetPreSubmissionInfoQuery,
    type GetPreSubmissionInfoQueryVariables,
} from "../api/queries/getPreSubmissionInfo.gql-generated";

export const useSubmittingLens = (): ApolloResult<{
    data: GetAllPreSubmissionInfoWithOrgResourcesQuery | GetPreSubmissionInfoQuery | undefined;
    submissionId: string | undefined;
}> => {
    const { submissionId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT]>();

    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const { data: dataV1, loading: loadingV1 } = useQuery<
        GetAllPreSubmissionInfoWithOrgResourcesQuery,
        GetAllPreSubmissionInfoWithOrgResourcesQueryVariables
    >(getAllPreSubmissionInfoWithOrgResources, {
        variables: { submissionId },
        skip: isMyLensesOrgsV2Enabled,
    });

    const { data: dataV2, loading: loadingV2 } = useQuery<
        GetPreSubmissionInfoQuery,
        GetPreSubmissionInfoQueryVariables
    >(getPreSubmissionInfoQuery, {
        variables: { submissionId },
        skip: !isMyLensesOrgsV2Enabled,
    });

    const data = isMyLensesOrgsV2Enabled ? dataV2 : dataV1;

    return {
        data,
        loading: isMyLensesOrgsV2Enabled ? loadingV2 : loadingV1,
        submissionId,
    };
};
